
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/amazon-kinesis",
      function () {
        return require("private-next-pages/destinations/amazon-kinesis.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/amazon-kinesis"])
      });
    }
  